import extend from "../modules/extend";

export default class Tabs {
    constructor(...ops) {
        extend(
            this,
            {
                selector: "tabs__tab"
            },
            ops
        );

        this.panels = [];
        this.setTabs();
        this.bindTabs();
    }

    setTabs() {
        this.tabs = document.getElementsByClassName(this.selector);
    }
    bindTabs() {
        for (var i = 0; i < this.tabs.length; i++) {
            this.tabs[i].addEventListener("click", () => {
                this.changeTab(this.tabs[i]);
            });
        }
        if (this.tabs.length > 0) {
            this.changeTab(this.tabs[0]);
        }
    }

    changeTab(element) {
        let targetPanelID = element.getAttribute("data-tab");
        for (var i = 0; i < this.tabs.length; i++) {
            let curTabID = this.tabs[i].getAttribute("data-tab");
            let curTabPanel = document.getElementById(curTabID);
            if (targetPanelID == curTabID) {
                this.show(curTabPanel);
                this.addClass(this.tabs[i], "tabs__tabActive");
            } else {
                this.hide(curTabPanel);
                this.removeClass(this.tabs[i], "tabs__tabActive");
            }
        }
    }

    addClass(el, className) {
        el.classList.add(className);
    }

    removeClass(el, className) {
        el.classList.remove(className);
    }

    show(el) {
        if (el) el.style.display = "";
    }

    hide(el) {
        el.style.display = "none";
    }
}
